<form class="model-meta-data-form row m-0 pt-1" [formGroup]="form" *ngIf="form">
  <ng-container *ngFor="let model of models">
    <ng-container *ngIf="model.DisplayStatus !== display.Hidden">
      <ng-container *ngTemplateOutlet="modelTemplate; context: { $implicit: model }"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #modelTemplate let-model>
    <div
      class="col-lg-6"
      [ngClass]="{
        'col-lg-6': model.DisplayStatus === display.Half,
        'col-lg-12': model.DisplayStatus === display.Full,
      }"
    >
      <ng-container [ngSwitch]="model.PropertyTypeCode">
        <!-- Title -->
        <ng-container *ngSwitchCase="propertyTypeCode.Title">
          <div class="form-group mb-4">
            <div class="form-floating">
              <select id="title" class="form-select" [formControlName]="model.PropertyName">
                <option value="Mr">Mr.</option>
                <option value="Mrs">Mrs.</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms.</option>
                <option value="O">Other</option>
              </select>
              <label for="title"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>

            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Gender -->
        <ng-container *ngSwitchCase="propertyTypeCode.Gender">
          <div class="form-group mb-4">
            <div class="form-floating">
              <select id="gender" class="form-select" [formControlName]="model.PropertyName">
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="O">Other</option>
              </select>
              <label for="gender"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Text Box -->
        <ng-container *ngSwitchCase="propertyTypeCode.String">
          <div class="form-group mb-4">
            <div class="form-floating">
              <input id="string" type="text" class="form-control" [formControlName]="model.PropertyName" />
              <label for="string"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('empty') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.empty' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Number -->
        <ng-container *ngSwitchCase="propertyTypeCode.Number">
          <div class="form-group mb-4">
            <div class="form-floating">
              <input
                id="number"
                type="number"
                class="form-control"
                [formControlName]="model.PropertyName"
                (keydown)="onNumberKeydown($event)"
                (input)="onNumberInput($event)"
              />
              <label for="number"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Decimal -->
        <ng-container *ngSwitchCase="propertyTypeCode.Decimal">
          <div class="form-group mb-4">
            <div class="form-floating">
              <input id="decimal" type="number" class="form-control" [formControlName]="model.PropertyName" />
              <label for="decimal"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Char -->
        <ng-container *ngSwitchCase="propertyTypeCode.Char">
          <div class="form-group mb-4">
            <div class="form-floating">
              <input id="char" type="text" class="form-control" [formControlName]="model.PropertyName" maxlength="1" />
              <label for="char"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Date of Birth -->
        <ng-container *ngSwitchCase="propertyTypeCode.DateOfBirth">
          <div class="form-group mb-4">
            <div class="form-floating">
              <fgbcl-date-select
                [label]="wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate"
                [formControlName]="model.PropertyName"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [ariaLabel]="'registration.personal.details.dob.screenreader' | lowercase | translate"
              ></fgbcl-date-select>
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('invalidDate') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Date of Birth No Year -->
        <ng-container *ngSwitchCase="propertyTypeCode.DateOfBirthNoYear">
          <div class="form-group mb-4">
            <fgbcl-date-select-no-year
              [label]="wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate"
              [formControlName]="model.PropertyName"
              [ariaLabel]="'registration.personal.details.dob.no.year.screenreader' | lowercase | translate"
            ></fgbcl-date-select-no-year>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Date Time -->
        <ng-container *ngSwitchCase="propertyTypeCode.DateTime">
          <div class="form-group mb-4">
            <div class="form-floating">
              <fgbcl-date-select
                [label]="wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate"
                [formControlName]="model.PropertyName"
                [ariaLabel]="'registration.personal.details.' + model.PropertyName + '.screenreader' | lowercase | translate"
              ></fgbcl-date-select>
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Country -->
        <ng-container *ngSwitchCase="propertyTypeCode.Country">
          <div class="mb-3">
            <fgbcl-select-country
              [formControlName]="model.PropertyName"
              [label]="wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate"
              (countryChange)="onCountryChange($event)"
            ></fgbcl-select-country>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Region -->
        <ng-container *ngSwitchCase="propertyTypeCode.Region">
          <div class="form-group mb-4">
            <div class="form-floating">
              <fgbcl-select-region
                [formControlName]="model.PropertyName"
                [options]="regions"
                [label]="wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate"
              ></fgbcl-select-region>
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('empty') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.empty' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Boolean -->
        <ng-container *ngSwitchCase="propertyTypeCode.Boolean">
          <div class="form-group mb-4">
            <label
              >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
              }}<span *ngIf="model.IsRequired">*</span></label
            >
            <input class="form-control" type="checkbox" [formControlName]="model.PropertyName" />
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Post Code -->
        <ng-container *ngSwitchCase="propertyTypeCode.PostCode">
          <div class="form-group mb-4">
            <div class="form-floating">
              <input id="string" type="text" class="form-control" [formControlName]="model.PropertyName" />
              <label for="string"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('empty') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.empty' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Option -->
        <ng-container *ngSwitchCase="propertyTypeCode.Option">
          <div class="form-group mb-4">
            <div class="form-floating">
              <select id="title" class="form-select" [formControlName]="model.PropertyName">
                <option value="" selected hidden>
                  {{ wscPrefix + '.' + model.PropertyName + '.options.none.selected' | translate: { fgbdefault: '--Select--' } }}
                </option>
                <option [value]="option.value" *ngFor="let option of model.Options">{{ option.label | translate }}</option>
              </select>
              <label for="title"
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>

            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
        <!-- Default -->
        <ng-container *ngSwitchDefault>
          <div class="form-group mb-4">
            <div class="form-floating">
              <input type="text" class="form-control default" [formControlName]="model.PropertyName" />

              <label
                >{{ wscPrefix + '.' + model.PropertyName + '.label' | lowercase | translate
                }}<span *ngIf="model.IsRequired">*</span></label
              >
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('required') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.required' | lowercase | translate }}
            </div>
            <div
              class="error-message"
              *ngIf="form.get(model.PropertyName)?.hasError('pattern') && form.get(model.PropertyName)?.touched"
            >
              {{ wscPrefix + '.' + model.PropertyName + '.invalid' | lowercase | translate }}
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</form>
